import { createBreakpointMap } from './styled-helpers';
export var stopPropagationAndCallFunction = eventHandlerFunction => e => {
  e.stopPropagation();
  eventHandlerFunction();
};
export var createBreakpointMapTextSize = textSize => {
  if (textSize) {
    return createBreakpointMap(textSize);
  }

  return {
    mobile: 28,
    tablet: 28,
    desktop: 28
  };
};